import type { ListResponse } from './core-api-shared.interface';

export enum NumberActiveState {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ALL = 'all',
}

export type NumberConfig = {
  releaseAt?: string;
};

export type Number = {
  id: string;
  active: boolean;
  label: string;
  outbound_only: boolean;
  example_context: string | null;
  number: string;
  telephony_provider: string;
  area_code?: string;
  phone_number?: string;
  telephony_account_connection?: string;
  inbound_agent: string;
  inbound_agent_name: string;
  agent: string;
  description?: string;
  sms_enabled?: boolean;
  tags?: string[];
  config?: NumberConfig;
};

export type NumberTags = ListResponse<string>;

export type FormNumber = {
  telephony_provider: string;
  area_code?: string;
  phone_number?: string;
  telephony_account_connection?: string;
  inbound_agent: string;
  label?: string;
  description?: string;
  tags?: string[];
};

export type BulkBuyNumberResponse = {
  items: Number[];
  total: number;
  failures: {
    phone_number: string;
    error: string;
  }[];
};
